import { create } from 'zustand';
import { trackEvent } from '../amplitude';
import { AmplitudeEvents } from '../amplitude/events';

// Define the store's state and actions types
interface CartStore {
  isSheetCartOpen: boolean;
  handleOpenChange: (open: boolean) => void;
  handleCloseCartSheet: () => void;
}

// Create the Zustand store with types
const useToggleCartMenu = create<CartStore>((set) => ({
  isSheetCartOpen: false, // Initial state
  handleOpenChange: (open: boolean) => {
    set({ isSheetCartOpen: open });
    trackEvent(AmplitudeEvents.CART_ICON_CLICKED);
  }, // Update the open state
  handleCloseCartSheet: () => set({ isSheetCartOpen: false }), // Close the cart
}));

export default useToggleCartMenu;
